<template>
	<main class="products">
		<div class="products__inner _cnt">
			<div class="products__top top">
				<!--<BaseButton
					class="top__button"
					@click="back"
					:theme="ButtonThemes.BACK"
				>
					<svg
						width="24"
						height="14"
						viewBox="0 0 24 14"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M22.75 6.75H0.75M0.75 6.75L6.75 0.75M0.75 6.75L6.75 12.75"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span>{{ $t('Back') }}</span>
				</BaseButton>-->
				<div class="top__title _h1">{{ $t(pageTitleKey) }}</div>
				<div class="top__line _line"><span></span></div>
			</div>
			<div
				:class="[
					'products__body',
					{ products__body_open: isFilterMenuOpen },
				]"
			>
				<div
					:class="[
						'products__filters filters',
						{ filters_open: isFilterMenuOpen },
					]"
				>
					<BaseButton
						:class="[
							'filters__open',
							{ filters__open_open: isFilterMenuOpen },
						]"
						@click="toggleFilterMenu"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M23 12H1M1 12L7 6M1 12L7 18"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</BaseButton>
					<div class="filters__top">
						<p class="filters__title _md">{{ $t('Filters') }}</p>
						<BaseButton
							v-if="!isFiltersLoading"
							class="filters__reset _btn-bordered"
							@click="resetFilters"
							>{{ $t('Reset Filters') }}</BaseButton
						>
					</div>
					<div v-if="isFiltersLoading" class="filters__loading _md">
						{{ $t('Loading filters') }}...
					</div>
					<div v-else class="filters__inner">
						<RangeSlider
							:max-bar-value="PRICE_CEILING"
							:min-value="activeFilters.price_from"
							:max-value="activeFilters.price_till"
							@update-range="updatePriceFilter"
						/>
						<div class="filters__item">
							<div
								class="filters__name"
								:class="{
									filters__name_active: isSortVisibale,
								}"
								@click="toggleSortVisibility"
							>
								{{ $t('Sort by price') }}
							</div>
							<div
								class="filters__list"
								:class="{
									filters__list_hidden: isSortVisibale,
								}"
							>
								<BaseTermCheckbox
									:modelValue="sortOrder === 'desc'"
									:label="$t('Price: High to Low')"
									className="filters__checkbox"
									@update:modelValue="(val) => toggleSort(val, 'desc')"
								/>
								<BaseTermCheckbox
									:modelValue="sortOrder === 'asc'"
									:label="$t('Price: Low to High')"
									className="filters__checkbox"
									@update:modelValue="(val) => toggleSort(val, 'asc')"
								/>
							</div>
						</div>
						<div
							v-for="(filter, filterName) in visibleFilterOptions"
							:key="filterName"
							class="filters__item"
						>
							<div
								class="filters__name"
								:class="{
									filters__name_active:
										!expandedFilters.has(filterName),
								}"
								@click="toggleFilterVisibility(filterName)"
							>
								{{ $t(filter.translationKey) }}
							</div>
							<div
								class="filters__list"
								:class="{
									filters__list_hidden:
										!expandedFilters.has(filterName),
								}"
							>
								<BaseTermCheckbox
									v-for="option in filter.options"
									:key="option"
									:modelValue="activeFilters[filterName] === option"
									:label="$t(option)"
									className="filters__checkbox"
									@update:modelValue="
										(checked) =>
											onFilterToggle(filterName, option, checked)
									"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="products__content content">
					<div v-if="isLoading" class="content__loading">
						{{ $t('Loading') }}...
					</div>
					<div v-else-if="error" class="content__empty">
						<p class="content__error _l">{{ error }}</p>
						<BaseButton
							class="content__error-button _link-btn-primary"
							@click="fetchProducts"
							>{{ $t('Retry') }}</BaseButton
						>
					</div>
					<div
						v-else-if="productList.length > 0"
						:class="[
							'content__list',
							{ content__list_open: isFilterMenuOpen },
						]"
					>
						<div
							class="content__item"
							v-for="item in productList"
							:key="item.id"
						>
							<ProductCard
								:is-auth="isAuth"
								:chosenItem="chosenItem"
								:item="item"
								:currencySymbol="currencySymbol"
								:is-listing-page="true"
								:is-market="true"
								@goToProduct="goToProduct"
								@addToCart="addToCart"
							/>
						</div>
					</div>
					<div v-else class="content__empty">
						{{ $t('No products found') }}
					</div>
					<Pagination
						v-if="totalProducts > 0 && !isLoading"
						:total-pages="totalPages"
						:per-page="activeFilters.limit"
						:current-page="activeFilters.page"
						@update:per-page="updatePerPage"
						@update:current-page="changePage"
					/>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import BaseButton, { ButtonThemes } from '@/components/base/BaseButton.vue';
import BaseTermCheckbox from '@/components/base/BaseTermCheckbox.vue';
import RangeSlider from '@/components/RangeSlider.vue';
import { onClickOutside } from '@vueuse/core';
import { debounce, isEqual } from 'lodash';
import { mapGetters } from 'vuex';
import Pagination from '../components/PaginationComponent.vue';
import ProductCard from '../components/ProductCard.vue';

const PRICE_CEILING = 20000;
const DEFAULT_LIMIT = 12;

const DEFAULT_FILTERS = Object.freeze({
	sort: 'desc',
	page: 1,
	limit: DEFAULT_LIMIT,
	price_from: 0.0,
	price_till: PRICE_CEILING,
	types: 'all',
	qualities: 'all',
	heroes: 'all',
	exterior_names: 'all',
	classes: 'all',
	special_offers: 'all',
	search: '',
});

const FILTER_CONFIG = Object.freeze({
	types: { apiParam: 'type', translationKey: 'Types' },
	qualities: { apiParam: 'quality', translationKey: 'Qualities' },
	heroes: { apiParam: 'hero', translationKey: 'Heroes' },
	exterior_names: {
		apiParam: 'exterior_names',
		translationKey: 'Exterior Names',
	},
	classes: { apiParam: 'item_class', translationKey: 'Classes' },
	special_offers: {
		apiParam: 'special_offers',
		translationKey: 'Special Offers',
	},
});

export default {
	name: 'ProductListPage',
	components: {
		Pagination,
		ProductCard,
		RangeSlider,
		BaseButton,
		BaseTermCheckbox,
	},
	props: {
		chosenItem: String,
		type: String,
		itemType: String,
		isAuth: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			sortOrder: DEFAULT_FILTERS.sort,
			PRICE_CEILING,
			productList: [],
			totalProducts: 0,
			totalPages: 1,
			isLoading: true,
			isFiltersLoading: true,
			error: null,
			filtersIsVisible: true,
			isOpen: false,
			filterOptions: {},
			activeFilters: { ...DEFAULT_FILTERS },
			//expandedFilters: new Set(['types']),
			expandedFilters: new Set([]),
			ButtonThemes,
			isFilterMenuOpen: true,
			isSortVisibale: false,
		};
	},
	computed: {
		...mapGetters('app', ['currencySymbol', 'currencyCode']),
		selectedOptionText() {
			return this.activeFilters.sort === 'desc'
				? this.$t('Price: High to Low')
				: this.$t('Price: Low to High');
		},
		visibleFilterOptions() {
			const result = {};
			for (const key in this.filterOptions) {
				if (Object.prototype.hasOwnProperty.call(this.filterOptions, key)) {
					const filter = this.filterOptions[key];
					if (filter && filter.options && filter.options.length > 1) {
						result[key] = filter;
					}
				}
			}
			return result;
		},
		pageTitleKey() {
			// itemType = all из /products/all
			const itemType = this.$route.params.itemType;
			// special_offers=sale можем взять из активных фильтров или напрямую из query
			const specialOffers =
				this.activeFilters.special_offers ||
				this.$route.query.special_offers;

			const isDealsRoute = itemType === 'all' && specialOffers === 'sale';

			// Это ключи для $t – добавь 'Deals' в свои переводы, если его ещё нет
			return isDealsRoute ? 'Deals' : 'Market';
		},
	},
	watch: {
		'$route.query': {
			deep: true,
			handler(newQuery, oldQuery) {
				if (!isEqual(newQuery, oldQuery)) {
					this.syncStateFromUrl(newQuery);
					this.fetchProducts();
				}
			},
		},
		'$route.params.itemType': {
			handler(newType, oldType) {
				if (newType !== oldType) {
					this.initializePage();
				}
			},
		},
		// currencyCode(newCode, oldCode) {
		// 	if (newCode !== oldCode) {
		// 		this.fetchProducts();
		// 	}
		// },
		productList(newVal, oldVal) {
			console.log('newVal', newVal);
			console.log(' oldVal', oldVal);
		},
	},
	created() {
		this.updateAndFetchDebounced = debounce(this.updateAndFetch, 400);
		this.initializePage();
	},
	mounted() {
		onClickOutside(this.$refs.dropdownRef, () => {
			this.isOpen = false;
		});
	},
	methods: {
		toggleSortVisibility() {
			this.isSortVisibale = !this.isSortVisibale;
		},
		selectSortOption(sortValue) {
			this.isOpen = false;
			this.sortOrder = sortValue;
			this.updateAndFetch({ sort: sortValue });
		},
		toggleSort(checked, value) {
			// when a box is turned on, set that sort; when turned off, clear sort
			if (checked) this.selectSortOption(value);
			else {
				this.sortOrder = null;
				this.updateAndFetch({ sort: null }); // or omit to remove sorting
			}
		},
		async initializePage() {
			this.isLoading = true;
			this.isFiltersLoading = true;
			this.error = null;

			this.syncStateFromUrl(this.$route.query);

			try {
				await Promise.all([
					this.fetchFilterOptions(),
					this.fetchProducts(),
				]);
			} catch (err) {
				console.error('Initialization failed:', err);
				this.error = this.$t('Error loading page data');
				this.isLoading = false;
				this.isFiltersLoading = false;
			}
		},

		syncStateFromUrl(query) {
			const filters = { ...DEFAULT_FILTERS };
			filters.page = Math.max(1, parseInt(query.page, 10) || 1);
			filters.limit = parseInt(query.limit, 10) || DEFAULT_LIMIT;
			filters.sort = ['asc', 'desc'].includes(query.sort)
				? query.sort
				: DEFAULT_FILTERS.sort;
			filters.price_from = Math.max(0, parseFloat(query.price_from) || 0);
			filters.price_till = Math.min(
				PRICE_CEILING,
				parseFloat(query.price_till) || PRICE_CEILING
			);
			filters.search = query.search || DEFAULT_FILTERS.search;

			//const newExpandedFilters = new Set(['types']);
			const newExpandedFilters = new Set([]);
			for (const key in FILTER_CONFIG) {
				if (query[key] && query[key] !== 'all') {
					filters[key] = query[key];
					newExpandedFilters.add(key);
				}
			}
			this.activeFilters = filters;
			this.expandedFilters = newExpandedFilters;
		},

		getCleanQuery(filters) {
			const query = {};
			for (const key in filters) {
				if (
					filters[key] !== DEFAULT_FILTERS[key] &&
					filters[key] !== null &&
					filters[key] !== undefined
				) {
					query[key] = String(filters[key]);
				}
			}
			return query;
		},

		updateUrl() {
			const query = this.getCleanQuery(this.activeFilters);
			if (!isEqual(this.$route.query, query)) {
				this.$router.push({ query }).catch((err) => {
					if (err.name !== 'NavigationDuplicated') console.error(err);
				});
			}
		},

		updateAndFetch(newPartialFilters) {
			const newFilters = { ...this.activeFilters, ...newPartialFilters };
			// Reset page to 1 if any filter except pagination itself is changed
			if (!('page' in newPartialFilters)) {
				newFilters.page = 1;
			}

			this.activeFilters = newFilters;
			this.updateUrl();
			// The watcher will handle the fetch call after the URL is updated
		},

		buildApiParams() {
			const params = new URLSearchParams();
			const category = this.$route.params.itemType;
			if (category && category !== 'all')
				params.append('category', category);

			const {
				page,
				limit,
				sort,
				price_from,
				price_till,
				search,
				...restFilters
			} = this.activeFilters;

			params.append('page', page);
			params.append('limit', limit);
			params.append('sort', sort);
			params.append('price_from', price_from);
			if (price_till <= PRICE_CEILING) {
				params.append('price_till', price_till);
			}
			if (search) params.append('search', search);

			for (const key in restFilters) {
				const value = restFilters[key];
				const config = FILTER_CONFIG[key];
				if (config && value && value !== 'all') {
					if (key === 'special_offers' && value === 'sale') {
						params.append('sale', true);
					} else {
						params.append(config.apiParam, value);
					}
				}
			}
			return params;
		},

		async fetchProducts() {
			this.isLoading = true;
			this.error = null;
			try {
				const params = this.buildApiParams();
				const res = await this.$http.get(
					`items/list?${params.toString()}`
				);
				this.productList = res.data.payload || [];
				this.totalProducts = res.data.meta.total || 0;
				this.totalPages = res.data.meta.pages || 1;
			} catch (error) {
				this.error = this.$t('Error loading products');
				this.productList = [];
				this.totalProducts = 0;
				console.error('Error fetching products:', error);
			} finally {
				this.isLoading = false;
			}
		},

		async fetchFilterOptions() {
			this.isFiltersLoading = true;
			try {
				const params = new URLSearchParams();
				const category = this.$route.params.itemType;
				if (category && category !== 'all')
					params.append('category', category);

				const res = await this.$http.get(
					`items/filter-data?${params.toString()}`
				);
				const data = res.data?.payload ?? {};
				const newFilterOptions = {};

				for (const key in FILTER_CONFIG) {
					const config = FILTER_CONFIG[key];

					const raw = data[key];

					let optionsArray = [];

					if (key === 'types') {
						if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
							optionsArray = Object.keys(raw);
						} else if (Array.isArray(raw)) {
							optionsArray = raw;
						}
					} else {
						if (Array.isArray(raw)) {
							optionsArray = raw;
						}
					}

					const sanitizedOptions = [
						...new Set(
							optionsArray
								.filter((o) => o && String(o).trim())
								.map((o) => String(o).toLowerCase())
						),
					];

					newFilterOptions[key] = {
						...config,
						options: ['all', ...sanitizedOptions],
					};
				}

				if (data.special_offers && Array.isArray(data.special_offers)) {
					newFilterOptions.special_offers.options = [
						'all',
						...new Set(data.special_offers),
					];
				} else {
					newFilterOptions.special_offers.options = ['all', 'sale'];
				}
				this.filterOptions = newFilterOptions;
			} catch (error) {
				console.error('Error fetching filter options:', error);
				this.error = this.$t('Error loading filters');
			} finally {
				this.isFiltersLoading = false;
			}
		},

		//async fetchFilterOptions() {
		//	this.isFiltersLoading = true;
		//	try {
		//		const params = new URLSearchParams();
		//		const category = this.$route.params.itemType;
		//		if (category && category !== 'all')
		//			params.append('category', category);

		//		const res = await this.$http.get(
		//			`items/filter-data?${params.toString()}`
		//		);
		//		const data = res.data?.payload ?? {};
		//		const newFilterOptions = {};

		//		// helper: coerce any shape to array of strings
		//		const toStringArray = (raw) => {
		//			if (!raw) return [];
		//			// array already? use it
		//			let arr = Array.isArray(raw) ? raw : Object.values(raw);
		//			// flatten simple objects like {id: X, name: Y} to their name/string
		//			return arr
		//				.map((o) => {
		//					if (o == null) return null;
		//					if (typeof o === 'string' || typeof o === 'number')
		//						return String(o);
		//					// try common keys, else stringify
		//					return (
		//						o.name ?? o.title ?? o.label ?? o.value ?? String(o)
		//					);
		//				})
		//				.filter((s) => typeof s === 'string' && s.trim() !== '')
		//				.map((s) => s.toLowerCase());
		//		};

		//		for (const key in FILTER_CONFIG) {
		//			const config = FILTER_CONFIG[key];
		//			const options = toStringArray(data[key]);
		//			const unique = [...new Set(options)];
		//			newFilterOptions[key] = {
		//				...config,
		//				options: ['all', ...unique],
		//			};
		//		}

		//		// special_offers fallback (if API omits or gives non-array)
		//		const specials = toStringArray(data.special_offers);
		//		newFilterOptions.special_offers = {
		//			...FILTER_CONFIG.special_offers,
		//			options: [
		//				'all',
		//				...(specials.length ? [...new Set(specials)] : ['sale']),
		//			],
		//		};

		//		this.filterOptions = newFilterOptions;
		//	} catch (error) {
		//		console.error('Error fetching filter options:', error);
		//		this.error = this.$t('Error loading filters');
		//	} finally {
		//		this.isFiltersLoading = false;
		//	}
		//},

		resetFilters() {
			this.isFilterMenuOpen = false;

			const isDealsPage =
				this.$route.query.special_offers === 'sale' ||
				this.activeFilters.special_offers === 'sale';

			const baseFilters = { ...DEFAULT_FILTERS };

			if (isDealsPage) {
				baseFilters.special_offers = 'sale';
			}

			if (
				isEqual(
					this.getCleanQuery(this.activeFilters),
					this.getCleanQuery(baseFilters)
				)
			) {
				return;
			}

			this.updateAndFetch(baseFilters);
		},
		//selectSortOption(sortValue) {
		//	this.isOpen = false;
		//	this.updateAndFetch({ sort: sortValue });
		//},
		updatePriceFilter(range) {
			this.updateAndFetchDebounced({
				price_from: range.min,
				price_till: range.max,
			});
		},
		updateFilter(filterName, value) {
			this.updateAndFetch({ [filterName]: value });
		},
		changePage(page) {
			this.updateAndFetch({ page });
		},
		updatePerPage(newPerPage) {
			this.updateAndFetch({ limit: newPerPage });
		},
		toggleFilterVisibility(filterName) {
			const newSet = new Set(this.expandedFilters);
			if (newSet.has(filterName)) {
				newSet.delete(filterName);
			} else {
				newSet.add(filterName);
			}
			this.expandedFilters = newSet;
		},
		back() {
			this.$router.go(-1);
		},
		addToCart(item) {
			this.$emit('addToCart', item);
		},
		goToProduct(item) {
			this.$emit('goToProduct', item);
		},
		onFilterToggle(filterName, option, checked) {
			if (checked) {
				// choose this option (single-select)
				this.updateFilter(filterName, option);
			} else {
				// if user unchecks the currently selected one, clear it
				if (this.activeFilters[filterName] === option) {
					this.updateFilter(filterName, null);
				}
			}
		},
		toggleFilterMenu() {
			this.isFilterMenuOpen = !this.isFilterMenuOpen;
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.products {
	@include adaptiveValue('padding-top', 50, 20);
	@include adaptiveValue('padding-bottom', 50, 20);
	&__inner {
	}
	&__top {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 37, 20);
		}
	}
	&__body {
		display: flex;
		gap: 20px;
		transition: gap 0.3s ease 0s;
		@media (max-width: $md2) {
			gap: 0px;
			&_open {
				gap: 20px;
			}
		}
	}
	&__filters {
	}
	&__content {
		flex: 1 1 auto;
	}
}

.top {
	&__title {
		text-align: center;
		&:not(:last-child) {
			margin-bottom: 10px;
		}
		@media (max-width: $md2) {
			padding-right: 65px;
		}
	}
	&__line {
		max-width: 710px;
		margin: 0 auto;
	}
}

.filters {
	position: relative;
	@media (min-width: $md2) {
		@include adaptiveValue('min-width', 344, 290, 1470, 992, 1);
		@include adaptiveValue('max-width', 344, 290, 1470, 992, 1);
	}
	@media (max-width: $md2) {
		border-top: 1px solid var(--primary-color);
		position: fixed;
		top: 70px;
		left: -100%;
		width: 320px;
		padding: 25px 10px;
		background-color: var(--bg-primary-color);
		z-index: var(--fourth-z-index);
		top: 50px;
		transition: left 0.3s ease 0s;
		max-height: calc(100vh - 50px);
		overflow-y: auto;
	}
	&_open {
		@media (max-width: $md1) and (min-width: $md2) {
			width: 300px;
			min-width: 300px;
			max-width: 300px;
			.filters__title,
			.filters__inner {
				opacity: 1;
				visibility: visible;
				pointer-events: auto;
			}
		}
		@media (max-width: $md2) {
			left: 0px;
		}
	}
	&__top {
		display: flex;
		align-items: center;
		gap: 20px;
		justify-content: space-between;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 20);
		}
	}
	&__title {
		@media (max-width: $md1) and (min-width: $md2) {
			opacity: 0;
			visibility: hidden;
			pointer-events: none;
			transition: all 0.3s ease 0s;
			padding-right: 65px;
		}
		@media (max-width: $md2) {
			//padding-right: 65px;
		}
	}
	&__reset {
		min-height: 34px;
	}
	&__open {
		position: absolute;
		top: 0px;
		right: 0px;
		width: 50px;
		height: 50px;
		border-radius: var(--border-radius-primary);
		background-color: red;
		transition: background-color 0.3s ease 0s;
		transform: translate(40px, 0px);
		z-index: var(--fourth-z-index);
		transition: transform 0.3s ease 0s;
		svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%) rotate(0deg);
			width: 24px;
			height: 24px;
			transition: transform 0.3s ease 0s;
			path {
				stroke: var(--primary-color);
				transition: stroke 0.3s ease 0s;
				stroke-width: 2px;
			}
		}
		&_open {
			transform: translate(0px, 0px);
			svg {
				transform: translate(-50%, -50%) rotate(-180deg);
			}
		}
		@media (any-hover: hover) {
			&:hover {
				background-color: var(--hint-hover-color);
			}
		}
		@media (min-width: $md2) {
			@include hide-item;
		}
		@media (max-width: $md2) {
			position: fixed;
			top: 60px;
			left: auto;
			right: 0px;
			transform: translate(-10px, 0px);
		}
	}
	&__inner {
		//@media (max-width: $md1) and (min-width: $md2) {
		//	opacity: 0;
		//	visibility: hidden;
		//	pointer-events: none;
		//	transition: all 0.3s ease 0s;
		//}
		@media (max-width: $md2) {
			overflow-y: auto;
		}
	}
	&__item {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 27, 7);
		}
	}
	&__name {
		text-transform: uppercase;
		padding-right: 20px;
		position: relative;
		transition: color 0.3s ease 0s;
		cursor: pointer;
		&:not(:last-child) {
			margin-bottom: 8px;
		}
		&::after {
			content: '';
			position: absolute;
			right: 5px;
			top: 50%;
			transform: translateY(-50%) rotate(-180deg);
			width: 12px;
			height: 8px;
			background: url('../../src/assets/img/arrow-down.svg');
			background-size: 12px;
			background-position: center;
			background-repeat: no-repeat;
			transition: transform 0.3s ease 0s;
		}
		@media (any-hover: hover) {
			&:hover {
				color: var(--hint-color);
			}
		}
		&_active {
			&::after {
				transform: translateY(-50%) rotate(0deg);
			}
		}
	}
	&__list {
		column-gap: 20px;
		max-height: 305px;
		overflow-y: auto;
		transition: all 0.3s ease 0s;
		margin-top: 10px;
		background-color: var(--bg-secondary-color);
		padding: 10px 0px;
		border-radius: 10px;
		&_hidden {
			max-height: 0;
			margin-top: 0;
			overflow-y: hidden;
			padding: 0px;
		}
	}
	&__checkbox {
		padding: 8px 0px;
		text-transform: capitalize;
		flex: 0 1 calc(50% - 10px);
		padding-left: 10px;
		padding-right: 10px;
		@media (any-hover: hover) {
			&:hover {
				background-color: var(--bg-primary-color);
			}
		}
	}
}

.content {
	&__loading,
	&__empty {
		min-height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: 20px;
	}
	&__error {
		color: var(--error-color);
	}
	&__error-button {
		max-width: 300px;
	}
	&__list {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
		@media (max-width: $md1) {
			gap: 10px;
		}
		@media (max-width: 519.98px) {
			margin-left: -10px;
			margin-right: -10px;
			gap: 4px;
		}
		&_open {
			@media (max-width: $md1) and (min-width: $md2) {
				.content__item {
					flex: 0 1 calc(50% - 5px);
				}
			}
		}
	}
	&__item {
		flex: 0 1 calc(33.333% - 13.4px);
		transition: flex 0.3s ease 0s;
		@media (max-width: $md1) {
			flex: 0 1 calc(33.333% - 7px);
		}
		@media (max-width: $md3) {
			flex: 0 1 calc(50% - 5px);
		}
		@media (max-width: 519.98px) {
			flex: 0 1 calc(50% - 2px);
		}
	}
}
</style>
